import { useCallback, useEffect, useState } from 'react';
import ActivityService from '../services/ActivityService';
import { errorText } from '../utils/format';

const PAGE = 50;

/** Activity log with "load older" paging by created_at. */
export function useActivityViewModel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);
  const [hasMore, setHasMore] = useState(false);

  const loadFirst = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const rows = await ActivityService.list({ limit: PAGE });
      setItems(rows);
      setHasMore(rows.length === PAGE);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadFirst(); }, [loadFirst]);

  const loadMore = async () => {
    if (!items.length) return;
    setLoadingMore(true);
    try {
      const rows = await ActivityService.list({ limit: PAGE, before: items[items.length - 1].created_at });
      setItems((prev) => [...prev, ...rows]);
      setHasMore(rows.length === PAGE);
    } catch (err) {
      setError(new Error(errorText(err)));
    } finally {
      setLoadingMore(false);
    }
  };

  return {
    items, loading, loadingMore, error, hasMore, reload: loadFirst, loadMore,
  };
}
